import React from 'react';

import '../../styles/Footer/Footer.scss';

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footer__container">
          <p>
            Portfolio of Md Ashiq Shahariar
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
